import { ConsignmentEditProformaPage } from "@/features/consignment-settlement/pages/ConsignmentEditProformaPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-settlement/$id/edit")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["vendor_consignment.edit"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentEditProformaPage,
});
